<template>
<div>

	<div v-if="show == 'details'">
		<el-row>
  			<el-col :span="24">
				<el-button class="pull-right" :plain="true" type="primary" icon="el-icon-close" @click="handleCloseDetails"></el-button>
			</el-col>
		</el-row>
		<div>
			<slot name="details" :item="item"></slot>
		</div>
	</div>

	<div v-if="show == 'table'">
		<!-- <slot name="buttons">
			<el-button v-if="config.AddItemTitle && can.create" size="small" type="primary" icon="el-icon-plus" :plain="true" @xclick="$router.push(baseUrl + '/create')" @click="handleNew()">{{config.AddItemTitle}}</el-button>
			<slot name="additionalButtons"></slot>
		</slot> -->
		<el-data-table :resourceUrl="baseUrl" 
			ref="dataTable" 
			:filters="filters" 
			:externalFiltersValid="externalFiltersValidCrud" 
			@itemsFetched="handleItemsFetched" 
			:config="dataTableConfig">

			<template slot="filtersDescription">
				<slot name="crudFiltersDescription"></slot>
			</template>
			<template slot="filtersForm">
				<slot name="crudFiltersForm"></slot>
			</template>
			<template slot="selectedActions" slot-scope="scope">
				<slot name="crudSelectedActions" :checkedIds="scope.checkedIds"></slot>
			</template>
			<template slot="tableActions">
				<el-button v-if="config.AddItemTitle && can.create" size="small" type="primary" icon="el-icon-plus" :plain="true" @xclick="$router.push(baseUrl + '/create')" @click="handleNew()">{{config.AddItemTitle}}</el-button>
				<slot name="additionalButtons"></slot>
				<slot name="crudTableActions"></slot>
			</template>
			<template slot="columns">
				<slot name="table"></slot>
	            <el-table-column v-if="actions.length > 0"
	                label="Acciones"
	                :width="config.actionsColumnWidth || 150"
	                :align="config.actionsColumnAlign || 'center'">
	                <template slot-scope="scope">
		                <el-button-group>
							<slot name="rowActions" :row="scope.row" :idx="scope.$index"></slot>
		                    <el-button v-if="actions.indexOf('view') >= 0" size="small" type="primary" icon="el-icon-view" :plain="true"
		                    @click="handleView(scope.$index, scope.row)"></el-button>
		                    <el-button v-if="actions.indexOf('edit') >= 0 && can.update" size="small" type="primary" icon="el-icon-edit" :plain="true"
		                    @click="handleEdit(scope.$index, scope.row)"></el-button>
							<el-dropdown v-if="actions.indexOf('more') >= 0" @command="command => {command(scope.row)}"
							class="el-button" style="padding:0;border:0;margin:0;">
								<el-button size="small" type="primary" :plain="true" icon="el-icon-arrow-down"></el-button>
								<el-dropdown-menu slot="dropdown">
									<slot name="moreMenu"></slot>
								</el-dropdown-menu>
							</el-dropdown>
		                    <!-- <el-popover v-if="actions.indexOf('more') >= 0"
								placement="right"
								trigger="click">
								<slot name="moreMenu" :item="scope.row"></slot>
								<el-button size="small" type="primary" icon="el-icon-more" :plain="true" slot="reference"></el-button>
							</el-popover> -->
		                    <el-button v-if="actions.indexOf('delete') >= 0 && can.delete" size="small" type="danger" icon="el-icon-delete" :plain="true"
							@click="handleDelete(scope.$index, scope.row)"></el-button>
		                </el-button-group>
	                </template>
	            </el-table-column>
			</template>
		</el-data-table>

		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" v-loading="formLoading" class="el-crud-form">
			<el-form :model="value" label-position="right" :rules="validationRules" ref="el-crud-form">
				<slot name="form" :errors="errors"></slot>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">Cancelar</el-button>
				<el-button type="primary" @click="handleSubmit">Confirmar</el-button>
			</span>
	  	</el-dialog>
	</div>
</div>
</template>

<style>
/* .el-crud-form .el-form-item {
	margin-bottom: 0;
} */
.el-form-item__label {
    line-height: inherit;
}

.el-form-item__content {
    line-height: inherit;
}
.el-button--mini {
	padding: 7px;
}
</style>

<script type="text/javascript">
	import el_data_table from './el-data-table.vue';

	export default {
		name: 'el-crud',
		props: {
			name: String,
			baseUrl: String,
			config: Object,
			value: {
				type: Object,
				default: () => {}
			},
			actions: {
				type: Array,
				default: []
			},
			urlIdField: {
				type: String,
				default: 'id'
			},
			urlActionField: {
				type: String,
				default: 'action'
			},
			filters:{
				type: Object,
				default: function () {
					return {};
				}
			},
			validationRules:{
				type: Object,
				default: function () {
					return {};
				}
			},
			moreFunctions: Object,
			externalFiltersValid: {
				type: Boolean,
				default: function () {
					return null;
				}
			}
		},
        components: {
            'el-data-table': el_data_table,
        },
        data: function () {
        	let errors = {};
        	_.each(this.value, (val, field) => {
        		errors[field] = null;
			});
        	return {
	        	dialogFormVisible: false,
	        	edit: false,
	        	id: null,
	        	errors,
				show: 'table',
				can: {
					create: false,
					update: false,
					delete: false
				},
				formLoading: false,
				dataTableConfig: {
					level: (this.config.level != undefined) ? this.config.level : null
				},
				externalFiltersValidCrud: this.externalFiltersValid,
				item: {},
				lastFullPath: null,
	        }
        },
        computed: {
        	'dialogTitle': function () {
        		return this.edit ? this.config.EditItemTitle : this.config.AddItemTitle;
        	},
		},
		watch: {
			'externalFiltersValid': function (to) {
				this.externalFiltersValidCrud = to;
			},
			'$route': function (to) {
				if (to.path == this.baseUrl) {
					this.lastFullPath = to.fullPath;
				}
			},
		},
		mounted() {
			const name = this.name;
			if (name === 'employees') {
				this.can.create = this.$auth.can(['employees.crud', 'employees.create']);
				this.can.update = this.$auth.can(['employees.crud', 'employees.edit']);
				this.can.delete = this.$auth.can(['employees.crud', 'employees.delete']);
			} else if (name) {
				this.can.create = this.$auth.can([`config.crud_${name}`, `config.create_${name}`]);
				this.can.update = this.$auth.can([`config.crud_${name}`, `config.update_${name}`]);
				this.can.delete = this.$auth.can([`config.crud_${name}`, `config.delete_${name}`]);
			} else {
				this.can.create = true;
				this.can.update = true;
				this.can.delete = true;
			}
			if (this.$router.currentRoute.path == this.baseUrl) {
				this.lastFullPath = this.$router.currentRoute.fullPath;
			}
		},
        methods: {
            handleItemsFetched() {
                this.$emit('itemsFetched', true);
            },
        	handleNew() {
        		this.clearForm();
        		this.clearErrors();
        		this.dialogFormVisible = true;
        		this.id = null;
        		this.edit = false;
				this.$emit('newItem');
        	},
        	handleView: function (index, row) {
        		// console.log(index);
        		// console.log(row);
        		this.item = row;
        		this.show = 'details';
        	},
        	handleEdit: function (index, row) {
        		// console.log(index);
        		// console.log(row);
        		this.clearForm();
				this.dialogFormVisible = true;
				this.formLoading = true;
        		this.id = row.id;
        		this.clearErrors();
        		this.loadResource();
        		this.edit = true;
				this.$emit('editItem');
        	},
        	handleDelete: function (index, row) {
        		// console.log(index);
				// console.log(row);
				
				if (!this.can.delete) {
					alert('No tiene permisos para realizar esa operación');
					return;
				}

				this.$confirm(this.config.DeleteItemConfirmMessage, 'Cuidado', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancelar',
					type: 'warning'
				}).then(() => {
					axios.delete('/api' + this.baseUrl + '/' + row.id).then((response) => {
						// console.log(response);
						// this.$router.push(self.baseUrl);
						this.$refs['dataTable'].fetchItems();
						this.$notify({
							title: 'Operación exitosa',
							message: 'El registro se eliminó exitosamente',
							type: 'success'
						});
					}).catch((error) => {
						this.$notify.error({
							title: 'Error',
							message: (error.response.data.message)
						});
					});
				});
        	},
			loadResource: function () {
				// console.log(this.resourceUrl);
				const id = this.id;
				let resource = this.value;
				axios.get('/api' + this.baseUrl + '/' + this.id).then((response) => {
					_.each(resource, (val, field) => {
						if (resource[field] != null && typeof resource[field] == 'object' && 'setValue' in resource[field]) {
							resource[field].setValue(response.data);
						} else if (field.endsWith('_id') && response.data[field] != undefined) {
							resource[field] = response.data[field].toString();
						} else {
							resource[field] = response.data[field];
						}
					});
					this.formLoading = false;
					this.$emit('input', resource);
				});
			},
			clearForm: function () {
				let resource = this.value;
				_.each(resource, (val, field) => {
					// console.log(field);
					if (resource[field] != null && typeof resource[field] == 'object' && 'setValue' in resource[field]) {
						// console.log('setValue');
						resource[field].setValue(null);
					} else {
						// console.log('null');
						resource[field] = null;
					}
				});
				this.edit = false;

				this.$emit('input', resource);
			},
        	clearErrors() {
	        	_.each(this.errors, (val, field) => {
	        		this.errors[field] = null;
	        	});
			},
			clearSelection() {
				this.$refs['dataTable'].clearSelection();
			},
        	handleCloseDetails: function () {
				// console.log('closeDetails');
				this.$router.push(this.lastFullPath);
        		this.show = 'table';
			},
			refresh() {
				this.$refs['dataTable'].fetchItems();
			},
			handleMoreCommand(command, row) {
				// console.log(command);
				// console.log(row);
				this.moreFunctions[command](row);
			},
			handleSubmit: function () {
				// this.dialogFormVisible = false

				if ((this.edit && !this.can.update) || !this.can.create) {
					alert('No tiene permisos para realizar esa operación');
					return;
				}

				this.$refs['el-crud-form'].validate((valid) => {
					if (valid) {

						this.clearErrors();

						let resource = {};
						_.each(this.value, (val, field) => {
							if (this.value[field] != null && typeof this.value[field] == 'object' && 'value' in this.value[field]) {
								if ('getValue' in this.value[field]) {
									resource[field] = this.value[field].getValue();
								} else {
									resource[field] = val.value;
								}
							} else {
								resource[field] = val;
							}
						});

						this.formLoading = true;
						if(this.edit){
							// console.log(resource);
							axios.patch('/api' + this.baseUrl + '/' + this.id, resource)
							.then((response) => {
								this.formLoading = false;
								// console.log(response);
								// this.$router.push(self.baseUrl);
								this.$refs['dataTable'].fetchItems();
								this.dialogFormVisible = false;
								this.$notify({
									title: 'Operación exitosa',
									message: 'La modificación se procesó exitosamente',
									type: 'success'
								});
							})
							.catch((error) => {
								this.formLoading = false;
								// console.log(error.response);
								if (error.response.status == 422) {
									_.each(error.response.data, (value, key) => {
										this.errors[key] = value.join(', ');
									});
								} else {
									this.$notify.error({
										title: 'Error',
										message: (error.response.data.message)
									});
								}
							});
						}else{
							axios.post('/api' + this.baseUrl, resource)
							.then((response) => {
								this.formLoading = false;
								// console.log(response);
								// this.$router.push(self.baseUrl);
								this.$refs['dataTable'].fetchItems();
								this.dialogFormVisible = false;
								this.$notify({
									title: 'Operación exitosa',
									message: 'El registro se procesó exitosamente',
									type: 'success'
								});

							})
							.catch((error) => {
								this.formLoading = false;
								if (error.response.status == 422) {
									_.each(error.response.data, (value, key) => {
										this.errors[key] = value.join(', ');
									});
								} else {
									this.$notify.error({
										title: 'Error',
										message: (error.response.data.message)
									});
								}
							});
						}
					} else {
						return false;
					}
				});
			}
        }
	}
</script>